import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const STORAGE_KEY = 'cookie_notice_dismissed';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 pointer-events-none"
      data-testid="cookie-banner"
    >
      <div className="pointer-events-auto mx-auto max-w-3xl px-4 pb-4">
        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4 rounded-lg border border-border bg-background/95 backdrop-blur px-5 py-3 shadow-lg text-sm text-muted-foreground">
          <p className="text-center sm:text-left">
            We use local storage and similar technologies to keep the platform functioning properly. Learn more in our{' '}
            <Link to="/cookie-policy" className="underline text-foreground hover:text-orange-600" data-testid="cookie-policy-link">
              Cookie Policy
            </Link>.
          </p>
          <Button
            size="sm"
            onClick={dismiss}
            className="shrink-0"
            data-testid="cookie-dismiss-btn"
          >
            Got it
          </Button>
        </div>
      </div>
    </div>
  );
}
